var map = {
	"./": [
		"/tqd",
		"chunk-c66a"
	],
	"./dsbridge": [
		"yyvf",
		"chunk-30fe"
	],
	"./dsbridge.vue": [
		"yyvf",
		"chunk-30fe"
	],
	"./dsbridge2": [
		"YADS",
		"chunk-c0ac"
	],
	"./dsbridge2.vue": [
		"YADS",
		"chunk-c0ac"
	],
	"./index": [
		"/tqd",
		"chunk-c66a"
	],
	"./index.vue": [
		"/tqd",
		"chunk-c66a"
	],
	"./inputfile": [
		"HYfE",
		"b0Xh",
		"chunk-7ba5"
	],
	"./inputfile.vue": [
		"HYfE",
		"b0Xh",
		"chunk-7ba5"
	],
	"./leaderboard": [
		"7yHj",
		"chunk-1d63"
	],
	"./leaderboard.vue": [
		"7yHj",
		"chunk-1d63"
	],
	"./routes": [
		"bno9"
	],
	"./routes.js": [
		"bno9"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "xP3n";
module.exports = webpackAsyncContext;